import React, { useEffect } from 'react'
import s from './UserAccountIncentivePopin.less'
import { useAction } from '../../utils/react-redux'
import Modal from '../../genericComponents/Modal'
import { selectShouldDisplayUserAccountIncentivePopin } from '../../../store/userAccount/userAccount.selectors'
import useModal from '../../ui/useModal'
import { useSelector } from 'react-redux'
import { UserAccountIncentiveCarrousel } from './UserAccountIncentiveCarrousel'
import { MODAL_IDS } from '../../../store/ui/ui.constants'
import useEventCallback from '../../utils/useEventCallback'
import SVGIcon from '../../svg/SVGIcon'
import UserLoginButton from '../UserLoginButton'
import { INCENTIVE_NAME } from './incentive.constants'
import { isPE, withOnlyPE } from '../../Device'
import incentiveIllustration from '../anonymous/welcome-user-account.svg'
import { withUserNotConnected } from '../shared/withKeycloak'
import { dispatchTag } from '../../../store/analytics/analytics.actions'
import { TAG_MULTIPATH_CTA } from '../../../store/analytics/analytics.actionTypes'
import { PUB_TAG } from '../../analytics/PublisherTagsService'
import LogoMappyImg from '../../genericComponents/LogoMappyImg'

// webpack:BrowserOnly
const UserAccountIncentivePopin = () => {
  const shouldDisplayPopin = useSelector(selectShouldDisplayUserAccountIncentivePopin)
  const { displayModal, hideModal, isModalDisplayed } = useModal(MODAL_IDS.USER_ACCOUNT_INCENTIVE_POPIN)
  const execDispatchTag = useAction(dispatchTag)

  const onPopinClose = useEventCallback(hideModal)

  useEffect(() => {
    if (shouldDisplayPopin) {
      displayModal()
    }
  }, [shouldDisplayPopin])

  useEffect(() => {
    if (!isModalDisplayed) return

    execDispatchTag({
      type: TAG_MULTIPATH_CTA,
      tagInfo: { tag: PUB_TAG.PUB_COMPTE_PERSO_INCITATION, Incitation: INCENTIVE_NAME.incitationPrincipale },
      isImpression: true
    })
  }, [isModalDisplayed])

  return (
    <Modal modalId={MODAL_IDS.USER_ACCOUNT_INCENTIVE_POPIN}>
      <div className={s.popin}>
        <div className={s.connectionSection}>
          {isPE() && <img className={s.incentiveIllustration} src={incentiveIllustration} />}
          <p className={s.title1}>
            Le compte <LogoMappyImg />
          </p>
          <p className={s.title2}>c’est gratuit !</p>
          <SmallScreenText />
          <UserLoginButton />
        </div>
        <div className={s.onCloseButton} onClick={onPopinClose}>
          <SVGIcon icon={'croix-android'} />
        </div>
        <UserAccountIncentiveCarrousel />
      </div>
    </Modal>
  )
}

const SmallScreenText = withOnlyPE(() => {
  return (
    <ul className={s.list}>
      <li>Des itinéraires personnalisés</li>
      <li>Des infos durée et coût plus précises</li>
      <li>Mes adresses favorites sur le site et l’appli</li>
    </ul>
  )
})

export default withUserNotConnected(UserAccountIncentivePopin)
